import { LeaderboardListItem } from "components";
import type { LeaderboardItemType } from "./types";

type Props = {
	leaderboards: LeaderboardItemType[];
	userLeaderboardItem?: LeaderboardItemType;
	avatarType?: "initials" | "identicon";
};

const LeaderboardList = (props: Props) => {
	const { leaderboards, avatarType } = props;

	const bottomLeaderboards = leaderboards.slice(3);

	const leaders = bottomLeaderboards.slice(0, 7);

	return (
		<>
			{leaders.map(({ username, xp, avatar }, index) => (
				<LeaderboardListItem
					key={username}
					title={username}
					xp={xp}
					image={avatar}
					rank={index + 4}
					avatarType={avatarType}
				/>
			))}
		</>
	);
};

export default LeaderboardList;
